import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionHeader: {
    description: 'Subheader for the import csv section',
    defaultMessage: 'Import CSV',
    id: 'dzLrIH',
  },
  sectionDescription: {
    description: 'Description for the import csv section',
    defaultMessage: 'Upload a CSV to set your current stock counts.',
    id: 'bid7mI',
  },
  importButton: {
    description: 'Button to import csv',
    defaultMessage: 'Import CSV',
    id: 'SYvX7i',
  },
});
